// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { organizationManagementPermissionsGuard } from './../foundations/index.js';
import { OrganizationManagementRoleType } from './custom-types.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable().optional(),
    type: z.nativeEnum(OrganizationManagementRoleType).optional(),
    permissions: organizationManagementPermissionsGuard.optional(),
    createdAt: z.number().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable(),
    type: z.nativeEnum(OrganizationManagementRoleType),
    permissions: organizationManagementPermissionsGuard,
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const OrganizationManagementRoles = Object.freeze({
    table: 'organization_management_roles',
    tableSingular: 'organization_management_role',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        organizationId: 'organization_id',
        name: 'name',
        description: 'description',
        type: 'type',
        permissions: 'permissions',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'organizationId',
        'name',
        'description',
        'type',
        'permissions',
        'createdAt',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
